<template>
    <div class="mb-8">
        <hr class="separator">
    </div>
</template>
